import { inject, Injectable } from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { CmsContentMapperService } from './cms-content-mapper.service';
import { map } from 'rxjs/operators';
import { ContentUpdaterService } from './content-updater/content-updater.service';

@Injectable({
  providedIn: 'root'
})
export class BannersService {
  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _contentUpdater = inject(ContentUpdaterService);


  /**
   * Returns banner item from CMS and prepare for using in Frontend
   *
   * @param params
   */
  item(params: object = {}) {
    return this._contentUpdater.registerContent('banner/item', params, () =>
      this._api.bannerItem(params).pipe(
        map(response => this._mapper.mapCmsData(response.data)),
      ),
    );
  }


  /**
   * Returns banner list from CMS and prepare for using in Frontend
   *
   * @param params
   */
  list(params: object = {}) {
    return this._contentUpdater.registerContent('banner/list', params, () =>
      this._api.bannerList(params).pipe(
        map(response => this._mapper.mapCmsData(response.data))
      )
    );
  }
}
